export enum OrderSchemeCode {
	IOSS_NON_UNION = 'IOSS-NON-UNION',
	IOSS_UNION = 'IOSS-UNION',
	IOSS_IMPORT = 'IOSS-IMPORT',
	FC = 'FC-',
	// FC_SIMPLE_REP: 'FC-SIMPLE-REP',
	B2B_INTRA_COMMUNAL = 'B2B-INTRA-COMMUNAL',
	B2B_DOMESTIC = 'B2B-DOMESTIC',
	B2C_DOMESTIC = 'B2C-DOMESTIC',
	GIFTCARD_SCHEME = 'GIFTCARD_SCHEME',
	NON_EU_IMPORT = 'NON_EU_IMPORT',
	NON_EU_DOMESTIC = 'NON_EU_DOMESTIC',
	EI_FACILITATION = 'EI_FACILITATION',
}

export enum OrderSchemeName {
	'IOSS-NON-UNION' = 'Non-Union OSS',
	'IOSS-UNION' = 'OSS',
	'IOSS-IMPORT' = 'IOSS',
	'FC-REP' = 'DDP/DDU Sales',
	'FC-SIMPLE-REP' = 'DDP/DDU Sale',
	'B2B-INTRA-COMMUNAL' = 'B2B',
	'B2B-DOMESTIC' = 'B2B Domestic',
	'B2C-DOMESTIC' = 'B2C Domestic',
	GIFTCARD_SCHEME = 'Gift Cards',
	NON_EU_IMPORT = 'NON EU Import',
	NON_EU_DOMESTIC = 'NON EU Domestic',
	EI_FACILITATION = 'Marketplace Sales',
}

export const representationSchemeType = {
	'IOSS-NON-UNION': 'Non-Union OSS',
	'IOSS-UNION': 'OSS',
	'IOSS-IMPORT': 'IOSS',
	'FC-REP': 'DDP/DDU Sales',
	// 'FC-SIMPLE-REP': 'DDP/DDU Sales',
	'B2B-INTRA-COMMUNAL': 'B2B',
	'B2B-DOMESTIC': 'B2B Domestic',
	'B2C-DOMESTIC': 'B2C Domestic',
	GIFTCARD_SCHEME: 'Gift Cards',
	NON_EU_IMPORT: 'NON EU Import',
	NON_EU_DOMESTIC: 'NON EU Domestic',
	EI_FACILITATION: 'Marketplace Sales',
};

export enum ESalesTypes {
	B2B = 'B2B',
	B2C = 'B2C',
}
